import { render } from "./wangEditor.vue?vue&type=template&id=007d0d82"
import script from "./wangEditor.vue?vue&type=script&lang=js"
export * from "./wangEditor.vue?vue&type=script&lang=js"

import "@wangeditor/editor/dist/css/style.css?vue&type=style&index=0&lang=css"

import exportComponent from "/var/jenkins_home/workspace/edu2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__